exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".nav-filter {\n  border-radius: 0 !important;\n}\n.nav-filter input {\n  border-radius: 0;\n  background-color: #edf3f7;\n  opacity: 0.85;\n  border-radius: 0 !important;\n}\n.nav-filter input:focus {\n  opacity: 1;\n}\n::placeholder {\n  color: black !important;\n  opacity: 0.7;\n}\ninput:focus::placeholder {\n  opacity: 1;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js!./src/styles/components/nav.less
// module id = 2589
// module chunks = 0